import { createSelector } from "@reduxjs/toolkit";
import { openapi } from "../../openapi";

export const makeSelectArticleValidationSettings = (projectNo: number) => {
  const selectSettingsQuery = openapi.endpoints.getMultiplacerProjectArticleValidation.select({
    projectNo,
  });

  return createSelector([selectSettingsQuery], (result) => ({
    exclusions: [...(result.data?.ignoredCompCodes ?? [])].sort((a, b) =>
      a.compCode.localeCompare(b.compCode)
    ),
    canEdit: result.data?.canEdit ?? false,
  }));
};
